// Przycisk dodawania/usuwania produktu z porównywarki

import React, { FC } from 'react';
import { ArrowLeftRight } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useCompare } from 'context/CompareContext';
import styles from 'theme/components/containers/CompareButton/CompareButton.module.scss';

interface Props {
  productId: number;
  title?: string;
  image?: string;
}

const CompareButton: FC<Props> = ({ productId, title, image }) => {
  const { t } = useTranslation();
  const { addToCompare, removeFromCompare, isInCompare } = useCompare();
  const inCompare = isInCompare(productId);

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (inCompare) {
      removeFromCompare(productId);
    } else {
      addToCompare({ id: productId, title, image });
    }
  };

  return (
    <button
      className={`${styles.compareButton} ${inCompare ? styles.active : ''}`}
      onClick={handleClick}
      aria-label={inCompare ? t('Usuń z porównywarki') : t('Dodaj do porównywarki')}
      title={inCompare ? t('Usuń z porównywarki') : t('Dodaj do porównywarki')}
      type="button">
      <ArrowLeftRight />
    </button>
  );
};

export default CompareButton;